import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import ActionDelete from "material-ui/svg-icons/action/delete";
import {translate} from "admin-on-rest";

const linkToRecord = (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;

const DeleteButton = ({
  basePath = "",
  label = "aor.action.delete",
  record = {},
  translate
}) => (
  <FlatButton
    secondary
    label={label && translate(label)}
    icon={<ActionDelete />}
    containerElement={
      <Link to={`${linkToRecord(basePath, record.id)}/delete`} />
    }
    hoverColor="transparent"
    fullWidth
    style={{overflow: "inherit", textAlign: "left"}}
  />
);

DeleteButton.propTypes = {
  basePath: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired
};

export default translate(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/CRM/DeleteButton.js